const config = {
	debugMode: false,
};

export default config;